import { clientesApi } from "page/OrderResumePag/_services/api";
import api from "../../../_services/api";

export async function getAddress(customerUuid, addressUuid) {
  const response = await api.get(
    `/api/list-address?addressUuid=${addressUuid}&customerUuid=${customerUuid}`,
  );
  return response.data;
}

export async function addAddress(cpf, address) {
  const payload = mapAddressPayload(address);

  const response = await clientesApi.post(`/customer/${cpf}/address`, payload);
  return response;
}

export async function deleteAddress(cpf, addressUuid) {
  const response = await clientesApi.delete(
    `/customer/${cpf}/address/${addressUuid}`,
  );
  return response.data;
}

export async function getAddresses(cpf) {
  const response = await clientesApi.get(`/customer/${cpf}/address`);
  return response.data.data;
}

export async function editAddresses(cpf, address) {
  const addressCopy = { ...address };
  addressCopy.addressUuid = addressCopy.uuid;
  delete addressCopy.uuid;

  const pld = mapAddressPayload(addressCopy);
  const response = await clientesApi.put(
    `/customer/${cpf}/address/${addressCopy.addressUuid}`,
    pld,
  );
  return response;
}

function mapAddressPayload(address) {
  return {
    label: address.label,
    streetName: address.streetName,
    neighborhood: address.neighborhood,
    complement: address.complement,
    number: address.number,
    zipCode: address.cep || address.zipCode,
    city: address.city,
    state: address.state,
    main: Boolean(address.main),
    recipient: address.recipient,
    reference: address.reference,
  };
}
